export const routeFor = (path, ...vars) => {
  let newPath = path;
  for (let pathVar = 0; pathVar < vars.length; pathVar += 1) {
    newPath = newPath.replace(/:\w+/, vars[pathVar]);
  }

  return newPath;
};

export default {
  home: {
    index: '/',
  },
  products: {
    index: '/services',
    show: '/services/:categorySlug/:productSlug',
    category: '/services/:categorySlug',
  },
  caseStudy: {
    index: '/work',
    show: '/work/:id',
    category: '/work/category/:id',
  },
  bookMarketer: {
    index: '/marketing-consultation',
  },
  blog: {
    index: '/tapd-in',
    show: '/tapd-in/:id',
    category: '/tapd-in/category/:id',
  },
};



// WEBPACK FOOTER //
// ./src/helpers/routes.js